import { useState } from 'react'
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material'
import ViewColumnIcon from '@mui/icons-material/ViewColumn'
import ViewColumnOutlinedIcon from '../../assets/iconComponents/ViewColumnOutlinedIcon'
import ViewHierarchicalIcon from '../../assets/iconComponents/ViewHierarchicalIcon'

const ViewDropdown = ({ view, setView }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleChangeView = (selectedView) => {
    setView(selectedView)
    handleMenuClose()
  }

  return (
    <Box className="pagesListView">
      <Button
        className='pagesListViewTitleContainer'
        variant="text"
        color="secondary"
        onClick={handleMenuOpen}
      >
        <ViewColumnIcon className='pagesListViewTitleIcon'/>
        <Typography className='pagesListViewTitleText'>{view}</Typography>
      </Button>
      <Menu
        className='pagesListViewDropdownMenu'
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          className='pagesListViewDropdownMenuItemContainer'
          value="Table"
          onClick={() => handleChangeView("table")}
        >
          <ViewColumnOutlinedIcon />
          <Typography className='pagesListViewDropdownMenuItemTitle'>Table</Typography>
        </MenuItem>
        <MenuItem
          className='pagesListViewDropdownMenuItemContainer'
          value="Hierarchical"
          onClick={() => handleChangeView("hierarchical")}
        >
          <ViewHierarchicalIcon />
          <Typography className='pagesListViewDropdownMenuItemTitle'>Hierarchical</Typography>
        </MenuItem>
      </Menu>
    </Box>
  )
}

export default ViewDropdown